

  <div class="row">
    <div class="col-md-12">
      <h2>Single Payment Verified List</h2>

      <mat-form-field>
          <input matInput (change)="applyFilterView($event)" placeholder="Filter">
      </mat-form-field>

      <!-- <button class="btn btn-primary" mat-raised-button (click)="exporter.exportTable('xlsx', {fileName:'singlepayverifylist', sheet: 'sheet_name', Props: {Author: 'nimi'}})">Download</button> -->

      <a class="btn btn-primary" href="https://nimionlineadmission.in/dgt/downloaddataxls.php">Download</a>
      <!-- <button class="btn btn-primary" (click)="update_fn()">Update Verified List</button> -->
      <div class="example-container mat-elevation-z8">
          <mat-table matTableExporter #exporter="matTableExporter" [dataSource]="dataSource_view" #t1Sort="matSort" matSort>

              <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->

              <!-- Position Column -->
              <ng-container matColumnDef="ticketId">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> Ticket Id </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.ticketId}} </mat-cell>
              </ng-container>


              <!-- Name Column -->
              <ng-container matColumnDef="ccrefno">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> cc refno </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.ccrefno}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="ccrefnostatus">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> cc refno status </mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.ccrefnostatus}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="ccorder">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Order No  </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.cc_orderno}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="ccdate">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Transaction Date </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.cc_date}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="ccamount">
            <mat-header-cell *matHeaderCellDef mat-sort-header> amount  </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.verify_cc}} </mat-cell>
        </ng-container>


        <ng-container matColumnDef="ccverify">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Reg No  </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.cc_orderno}} </mat-cell>
      </ng-container>



              <!-- Symbol Column -->
              <ng-container matColumnDef="admin_status">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> Amount
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">  {{element.cc_amount}} </mat-cell>
              </ng-container>

              <!-- Symbol Column -->
              <ng-container matColumnDef="action">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> Action </mat-header-cell>
                  <mat-cell *matCellDef="let row"> <button class="btn btn-success" (click)="selected_view.select(row)"
                          (click)="report_view()">View</button>
                  </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumns_view"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns_view;"></mat-row>

          </mat-table>
          <mat-paginator #t1Paginator="matPaginator"  [length]="totallength" (page)="pageEvent = $event; pageChanged($event)" [pageSizeOptions]="[ 5,10, 25, 50, 100, 500]"></mat-paginator>


      </div>

    </div>
  </div>




  <div class="row">
    <div class="col-md-12">
      <h2>Bulk Payment  List</h2>
      <mat-form-field>
          <input matInput (change)="applyFilterBulkView($event)" placeholder="Filter">
      </mat-form-field>
      <a class="btn btn-primary" href="https://nimionlineadmission.in/dgt/downloaddatabulkxls.php">Download</a>


      <div class="example-container mat-elevation-z8">
          <mat-table [dataSource]="dataSource_bulkview" #b1Sort="matSort" matSort>

           
            <ng-container matColumnDef="ticketId">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Ticket Id </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.ticketId}} </mat-cell>
            </ng-container>


            <!-- Name Column -->
            <ng-container matColumnDef="ccrefno">
                <mat-header-cell *matHeaderCellDef mat-sort-header> cc refno </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.ccrefno}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="ccrefnostatus">
                <mat-header-cell *matHeaderCellDef mat-sort-header> cc refno status </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.ccrefnostatus}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="ccorder">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Order No  </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.cc_orderno}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="ccdate">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Transaction Date </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.cc_date}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="ccamount">
          <mat-header-cell *matHeaderCellDef mat-sort-header> amount  </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.verify_cc}} </mat-cell>
      </ng-container>


      <ng-container matColumnDef="ccverify">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Reg No  </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.cc_orderno}} </mat-cell>
    </ng-container>



            <!-- Symbol Column -->
            <ng-container matColumnDef="admin_status">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Amount
                </mat-header-cell>
                <mat-cell *matCellDef="let element">  {{element.cc_amount}} </mat-cell>
            </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="action">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Action </mat-header-cell>
              <mat-cell *matCellDef="let row"> <button class="btn btn-success" (click)="selected_view.select(row)"
                      (click)="report_view()">View</button>
              </mat-cell>
          </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumns_bulkview"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns_bulkview;"></mat-row>

          </mat-table>

          <mat-paginator #b1Paginator="matPaginator"  [length]="totallength_mat_two" (page)="pageEvent_mat_two = $event; pageChanged_mat_two($event)" [pageSizeOptions]="[ 5,10, 25, 50, 100, 500]"></mat-paginator>


      </div>

    </div>
  </div>



  <div class="row">
    <div class="col-md-12">
      <h2>Direct NIMI Payment List</h2>
      <mat-form-field>
          <input matInput (change)="applyFilter_dirnimi($event)" placeholder="Filter">
      </mat-form-field>
      <a class="btn btn-primary" href="https://nimionlineadmission.in/dgt/downloaddatadirnimixls.php">Download</a>


      <div class="example-container mat-elevation-z8">
          <mat-table [dataSource]="dataSource_dirnimiview" #c1Sort="matSort" matSort>

           
            <ng-container matColumnDef="ticketId">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Ticket Id </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.ticketId}} </mat-cell>
            </ng-container>


            <!-- Name Column -->
            <ng-container matColumnDef="ccrefno">
                <mat-header-cell *matHeaderCellDef mat-sort-header> State </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.state}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="ccrefnostatus">
                <mat-header-cell *matHeaderCellDef mat-sort-header>   Name </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.name}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="ccorder">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Email  </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{element.email}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="ccdate">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Transaction Mobile Number </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.ascmob}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="paymethod">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Pay Method </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.paymethod}} </mat-cell>
        </ng-container>

        
            <!-- Symbol Column -->
            <ng-container matColumnDef="entrydate">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Grievance Date
                </mat-header-cell>
                <mat-cell *matCellDef="let element">  {{element.entrydate}} </mat-cell>
            </ng-container>

            
            <!-- Symbol Column -->
            <ng-container matColumnDef="amount">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Amount
                </mat-header-cell>
                <mat-cell *matCellDef="let element">  {{element.amount}} </mat-cell>
            </ng-container>


        <ng-container matColumnDef="admin_status">
          <mat-header-cell *matHeaderCellDef mat-sort-header>  Status  </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.admin_status}} </mat-cell>
      </ng-container>


      <!-- <ng-container matColumnDef="ccverify">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Description  </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.admin_status_description}} </mat-cell>
    </ng-container> -->




          <!-- Symbol Column -->
          <ng-container matColumnDef="action">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Action </mat-header-cell>
              <mat-cell *matCellDef="let row"> <button class="btn btn-success" (click)="selected_view.select(row)"
                      (click)="report()">View</button>
              </mat-cell>
          </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumns_dirnimiview"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns_dirnimiview;"></mat-row>

          </mat-table>

          <mat-paginator #c1Paginator="matPaginator"  [length]="totallength_mat_three" (page)="pageEvent_mat_three = $event; pageChanged_mat_three($event)" [pageSizeOptions]="[ 5,10, 25, 50, 100, 500]"></mat-paginator>


      </div>

    </div>
  </div>
